import React, { Dispatch, SetStateAction } from 'react';

import { WorkOrderType } from '@atom/types/work';
import { WorkTemplateFolderTree } from '@atom/types/workTemplate';

export const EMPTY_SCHEMA = 'empty';

export enum ModalView {
  MAIN = 'MAIN',
  FOLDER_TREE = 'FOLDER_TREE',
}

export enum ModalStep {
  DETAILS = 'DETAILS',
  TEMPLATE_TYPE = 'TEMPLATE_TYPE',
  INHERITANCE = 'INHERITANCE',
}

export interface ModalStepType {
  index: number;
  title: string;
  value: ModalStep;
}

export enum InheritanceType {
  REGULAR = 'REGULAR',
  INHERITANCE = 'INHERITANCE',
}

interface Context {
  activeView: ModalView;
  setActiveView: Dispatch<SetStateAction<ModalView>>;
  activeStep: ModalStep;
  setActiveStep: Dispatch<SetStateAction<ModalStep>>;
  error: string;
  setError: Dispatch<SetStateAction<string>>;
  name: string;
  setName: Dispatch<SetStateAction<string>>;
  workTemplateFolder: WorkTemplateFolderTree;
  setWorkTemplateFolder: Dispatch<SetStateAction<WorkTemplateFolderTree>>;
  schemaId: string;
  setSchemaId: Dispatch<SetStateAction<string>>;
  type: WorkOrderType;
  setType: Dispatch<SetStateAction<WorkOrderType>>;
  inheritanceType: InheritanceType;
  setInheritanceType: Dispatch<SetStateAction<InheritanceType>>;
  appointmentsEnabled: boolean;
  setAppointmentsEnabled: Dispatch<SetStateAction<boolean>>;
}

export const initialState: Context = {
  activeView: ModalView.MAIN,
  setActiveView: () => {},
  activeStep: ModalStep.DETAILS,
  setActiveStep: () => {},
  error: '',
  setError: () => {},
  name: '',
  setName: () => {},
  workTemplateFolder: null,
  setWorkTemplateFolder: () => {},
  schemaId: EMPTY_SCHEMA,
  setSchemaId: () => {},
  type: null,
  setType: () => {},
  inheritanceType: InheritanceType.REGULAR,
  setInheritanceType: () => {},
  appointmentsEnabled: false,
  setAppointmentsEnabled: () => {},
};

const WorkTemplateCreationModalContext =
  React.createContext<Context>(initialState);

export default WorkTemplateCreationModalContext;
